module.exports = __webpack_public_path__ + "site-build/img/mapIcon.9bbb1744.svg";